import React, { createContext, useState, useEffect } from "react";

export const ScreenSizeContext = createContext();

const ScreenSizeProvider = ({ children }) => {
  const [onMobile, setOnMobile] = useState(false);

  useEffect(() => {
    const maxSize = window.matchMedia("(max-width: 1250px)");
    if (maxSize.matches) {
      setOnMobile(true);
    }
  }, []);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1250) {
        setOnMobile(true);
      } else {
        setOnMobile(false);
      }
    }
    window.addEventListener("resize", handleResize);
  }, []);

  return (
    <ScreenSizeContext.Provider value={{ onMobile }}>
      {children}
    </ScreenSizeContext.Provider>
  );
};
export default ScreenSizeProvider;
